<template>
  <div class="loading-update" :class="[isLoading && 'loading']">
    <a-spin v-if="isSubmit" />
    <div class="content" v-else>
      <p v-text="$t('label.uploading')"></p>
      <p>{{ type }}</p>
      <a-progress
        type="circle"
        :width="50"
        :stroke-color="{
          '0%': '#108ee9',
          '100%': '#87d068',
        }"
        :percent="percent"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: true,
    },
    percent: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isSubmit() {
      return this.type === 'submit';
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-update {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  display: flex;
  z-index: 99999999;
  justify-content: center;
  align-items: center;
  transition: background 0.5s;
  background-color: transparent;
  pointer-events: none;
  opacity: 0;
  .ant-spin {
    /deep/ span {
      font-size: 30px;
      i {
        width: 15px;
        height: 15px;
        background-color: #fff;
      }
    }
  }
  &.loading {
    opacity: 1;
    background-color: rgba(#000, 0.5);
    pointer-events: initial;
  }
  .content {
    color: #fff;
    background: rgba(#000, 0.7);
    padding: 10px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    width: 115px;
    p {
      margin: 0;
    }
    /deep/ .ant-progress {
      &-text {
        color: #fff;
      }
    }
  }
}
</style>
